import React from "react";
import { Modal, Button } from "react-bootstrap";

export default function HelpModal({
  show,
  onHide,
  title = "Ajutor",
  size = "lg",
  children,
}) {
  return (
    <Modal show={show} onHide={onHide} size={size} scrollable>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ lineHeight: 1.5, minHeight: "80vh" }}>{children}</Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Închide (Esc)
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
